import {
    BILLING_CYCLES, BILLING_STATUS,
    BILLING_TIME,
    MEASUREMENT_TYPE, METERED_BILLING_STRATEGY,
    STATEFUL_BILLING_STRATEGY
} from 'src/features/servicePlanBillingPolicies/utils/types';
import { billingPoliciesMessages } from 'src/features/servicePlanBillingPolicies/utils/messages';
import { BadgeOption } from 'src/types';
import { ICON_MAP } from 'src/utils/constants';

export const BILLING_CYCLE_MAP: Record<BILLING_CYCLES, { id: string, defaultMessage: string}> = {
    [BILLING_CYCLES.ONE_TIME]: billingPoliciesMessages.oneTime,
    [BILLING_CYCLES.MONTHLY]: billingPoliciesMessages.monthly,
    [BILLING_CYCLES.QUARTERLY]: billingPoliciesMessages.quarterly,
    [BILLING_CYCLES.SEMIANNUALLY]: billingPoliciesMessages.semiannually,
    [BILLING_CYCLES.YEARLY]: billingPoliciesMessages.yearly,
};

export const BILLING_TIME_MAP: Record<BILLING_TIME, { id: string, defaultMessage: string}> = {
    [BILLING_TIME.ANNIVERSARY]: billingPoliciesMessages.anniversary,
    [BILLING_TIME.REGULAR]: billingPoliciesMessages.regular,
    [BILLING_TIME.CUSTOM]: billingPoliciesMessages.custom,
};

export const MEASUREMENT_TYPE_MAP: Record<MEASUREMENT_TYPE, { id: string, defaultMessage: string}> = {
    [MEASUREMENT_TYPE.STATEFUL]: billingPoliciesMessages.stateful,
    [MEASUREMENT_TYPE.METERED]: billingPoliciesMessages.metered,
};

export const STATEFUL_BILLING_STRATEGY_MAP: Record<STATEFUL_BILLING_STRATEGY, { id: string, defaultMessage: string}> = {
    [STATEFUL_BILLING_STRATEGY.TIME_WEIGHTED]: billingPoliciesMessages.timeWeighted,
    [STATEFUL_BILLING_STRATEGY.END_OF_PERIOD]: billingPoliciesMessages.endOfPeriod,
    [STATEFUL_BILLING_STRATEGY.MAX_IN_PERIOD]: billingPoliciesMessages.maxInPeriod,
};

export const METERED_BILLING_STRATEGY_MAP: Record<METERED_BILLING_STRATEGY, { id: string, defaultMessage: string}> = {
    [METERED_BILLING_STRATEGY.SUM]: billingPoliciesMessages.sum,
    [METERED_BILLING_STRATEGY.MAX]: billingPoliciesMessages.max,
    [METERED_BILLING_STRATEGY.LAST]: billingPoliciesMessages.last,
};

export const BILLING_CYCLE_BADGE_OPTIONS: Record<BILLING_CYCLES, BadgeOption> = {
    [BILLING_CYCLES.ONE_TIME]: {
        label: billingPoliciesMessages.oneTime,
        theme: 'green',
    },
    [BILLING_CYCLES.MONTHLY]: {
        label: billingPoliciesMessages.monthly,
        theme: 'orange',
    },
    [BILLING_CYCLES.QUARTERLY]: {
        label: billingPoliciesMessages.quarterly,
        theme: 'indigo',
    },
    [BILLING_CYCLES.SEMIANNUALLY]: {
        label: billingPoliciesMessages.semiannually,
        theme: 'pink',
    },
    [BILLING_CYCLES.YEARLY]: {
        label: billingPoliciesMessages.yearly,
        theme: 'cyan',
    },
}

export const BILLING_TIME_BADGE_OPTIONS: Record<BILLING_TIME, BadgeOption> = {
    [BILLING_TIME.ANNIVERSARY]: {
        label: billingPoliciesMessages.anniversary,
        theme: 'yellow',
    },
    [BILLING_TIME.REGULAR]: {
        label: billingPoliciesMessages.regular,
        theme: 'teal',
    },
    [BILLING_TIME.CUSTOM]: {
        label: billingPoliciesMessages.custom,
        theme: 'fuchsia',
    },
}


export const BILLING_STATUS_BADGE_OPTIONS: Record<BILLING_STATUS, BadgeOption> = {
    [BILLING_STATUS.CURRENT]: {
        label: billingPoliciesMessages.current,
        theme: 'green',
        icon: ICON_MAP.CURRENT
    },
    [BILLING_STATUS.PAST]: {
        label: billingPoliciesMessages.past,
        theme: 'red',
        icon: ICON_MAP.PAST
    },
    [BILLING_STATUS.SCHEDULED]: {
        label: billingPoliciesMessages.scheduled,
        theme: 'orange',
        icon: ICON_MAP.SCHEDULED
    },
};